import { DocumentNode } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'

export const APOLLO_STATE_PROP_NAME = '__APOLLO_STATE__'
export const isBrowser = typeof window !== 'undefined'
export const isDev = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'

export const isSubscription = (query: DocumentNode) => {
  const definition = getMainDefinition(query)
  return (
    definition.kind === 'OperationDefinition' &&
    definition.operation === 'subscription'
  )
}

export const customDevicesCacheMerge = {
  // Queries differing in these arguments have separate cache's
  keyArgs: ['filter'],

  merge(existing = { edges: [] }, incoming) {
    // Merge on edge level excluding potential duplicates
    const existingKeys = new Set(existing.edges.map((e) => e.node.__ref))
    const newEdges = [
      ...existing.edges,
      ...incoming.edges.filter((e) => !existingKeys.has(e.node.__ref)),
    ]
    return {
      ...incoming,
      edges: newEdges,
    }
  },
}
